<template>
  <div class="oci-projects-button-container">
    <b-button
      type="submit"
      @click="unableToAttend"
    >
      Unable to attend
    </b-button>
  </div>
</template>

<script>
import {
  BButton, BFormInput,
} from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import { checkInOutMethods } from '@/components/ui/CheckInOutFunctions'
import { messageBox } from '@/components/ui/MessageBox'
import { loginMethods } from '@/auth/rpc/ociLoginFunctions'
import swal from 'sweetalert2'

export default {
  name: 'UnableToAttendButton',
  components: {
    BButton,
    BFormInput,
  },
  props: {
    isMap: {
      type: Boolean,
      required: true,
    },
    longitude: {
      type: Number,
      required: false,
    },
    latitude: {
      type: Number,
      required: false,
    },
  },
  computed: {
    ...mapGetters({ checkedInStatus: 'app/getCheckedInStatus' }),
    ...mapGetters({ operativeSiteId: 'app/getCurrentSiteOperativeId' }),
    ...mapGetters({ site: 'app/getCurrentSite' }),
  },
  methods: {
    showWarningMessage(msgDescription, msgTitle) {
      swal.fire({
        title: msgTitle,
        text: msgDescription,
        icon: 'warning',
        confirmButtonText: 'Close X',
        customClass: {
          confirmButton: 'btn oci-close-button',
        },        
        buttonsStyling: false,
      })
    },  
    unableToAttend() {
      this.$router.push('/reason');
    },
  },
}
</script>
